export const hasActionAccesses = (
  actionAccessesList: { [accessName: string]: boolean },
  accesses: string | string[],
): boolean => {
  return Array.isArray(accesses)
    ? accesses.some((item: string) => !!actionAccessesList[item])
    : actionAccessesList[accesses];
};
